import React from "react";
import ViewPostReview from "./components/ViewPostReview";
import FormCreator from "../../components/forms/FormCreator";
import { PostReviewData } from "./data/PostReview.Data";
import Buttons from "../../components/ui/button/Buttons";

const PostReviewDetail = () => {
  return (
    <div>
      <div className="top-btn-sec">
        <div className="row">
          <div className="col-8">
            <Buttons
              // onClick={}
              buttonText={"Edit Details"}
              buttonTypeClassName="outline-theme-btn btn mt-auto"
              isLoading={false}
            />
          </div>
          <div className="col-4 d-flex mb-4 justify-content-between">
            <Buttons
              // onClick={}
              buttonText={"Cancel"}
              buttonTypeClassName="back-btn  btn mt-auto"
              isLoading={false}
            />
            <Buttons
              // onClick={}
              buttonText={"Save"}
              buttonTypeClassName="info-btn btn mt-auto"
              isLoading={false}
            />
            <Buttons
              // onClick={}
              buttonText={"Approve"}
              buttonTypeClassName="theme-btn btn mt-auto"
              isLoading={false}
            />
            <Buttons
              // onClick={}
              buttonText={"Draft"}
              buttonTypeClassName=" btn mt-auto"
              isLoading={false}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-8">
          <ViewPostReview />
        </div>
        <div className="col-4">
          <FormCreator
            config={PostReviewData}
            // ref={PostReviewRef}
            key={false}
          />
        </div>
      </div>
    </div>
  );
};

export default PostReviewDetail;
